import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import Grid from '../../../components/grid';

const gridStyles = `
  &:not(:first-of-type) {
    margin-top: 140px;

    ${screen.below(bp.mobile, `
      margin-top: 65px;
    `)};

    ${screen.below(bp.mobileSm, `
      margin-top: 10px;
    `)};
  }
`;

const AccountDetailGrid = ({ children, headline }) => (
  <Grid styles={gridStyles}>
    <DetailGridItem span={3}>
      <h4>{headline}</h4>
    </DetailGridItem>
    <DetailGridItem span={9}>
      {children}
    </DetailGridItem>
  </Grid>
);

AccountDetailGrid.propTypes = {
  children: PropTypes.node,
  headline: PropTypes.string,
};

export default AccountDetailGrid;

const DetailGridItem = styled(Grid.Item)`
  &:nth-of-type(2) {
    border-top: 5px solid ${props => props.theme.gray};
  }

  ${screen.below(bp.mobile, `
    grid-column: 1 / -1;

    &:not(:first-of-type) {
      margin-bottom: 40px;
    }
  `)};

  ${screen.below(bp.mobileSm, `
    &:not(:first-of-type) {
      margin-top: 15px;
    }
  `)};
`;
